import { z } from "zod";

export const ViewModeSchema = z.enum(["list", "table"]);
export type ViewMode = z.infer<typeof ViewModeSchema>;
export const ViewMode = ViewModeSchema.enum;
